module.exports = __webpack_public_path__ + "static/media/icon-email-blue.2048698f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-email-blue.svg
// module id = 1561
// module chunks = 0